import { render, staticRenderFns } from "./ColumnNextOrPreviousAppointment.vue?vue&type=template&id=692d3c8f&"
import script from "./ColumnNextOrPreviousAppointment.vue?vue&type=script&lang=ts&"
export * from "./ColumnNextOrPreviousAppointment.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports